<template>
  <div>
    <el-upload
      class="avatar-uploader"
      ref="upload"
      :show-file-list="false"
      :action="path"
      :auto-upload="false"
      :before-upload="beforeAvatarUpload"
      :on-change="fileChange"
      :http-request="post">
      <head-image v-if="imgUrl" :link-url="imgUrl" :size="size"></head-image>
      <i v-else :style="'width:'+size+'px;height:'+size+'px;line-height:'+size+'px'"
         class="el-icon-plus avatar-uploader-icon" id="icon"></i>
      <div v-show="imgUrl"   @mouseover.stop="cover = true" @mouseout.stop="cover = false" :class="cover?'opc':''" class="cover flex-mid flex-center flex">
        <i @click.stop="del" :style="'width:'+size+'px;height:'+size+'px;line-height:'+size+'px'" class="el-icon-delete white fs-20 flex-1"></i>
        <i @click.stop="view" :style="'width:'+size+'px;height:'+size+'px;line-height:'+size+'px'" class="el-icon-view white fs-20 flex-1"></i>
        <i  :style="'width:'+size+'px;height:'+size+'px;line-height:'+size+'px'" class="el-icon-plus white fs-20 flex-1"></i>
      </div>
    </el-upload>

    <el-dialog :visible.sync="dialogVisible" append-to-body>
      <img v-if="imgUrl" width="100%" :src="globalData.resourceUrl+imgUrl" alt="">
    </el-dialog>
  </div>

</template>
<script>
  import HeadImage from "./HeadImage";
  export default{
    components: {HeadImage},
    name: 'upload-img',
    props: ['url', 'type', 'length', 'value','file-name'],
    data(){
      return {
        params: {},
        size:this.length || 100,
        path: this.url || this.globalData.uploadHost,
        typ: this.type ? '/' + this.type + '/' : '/',
        dialogVisible: false,
        imgUrl: this.value || '',
        cover: false,
      }
    },
    mounted(){
    },
    methods: {
      success(path, file){
        this.imgUrl = path
      },
      error(file) {

      },
      getSignature(file){
        let suffix = file.name.lastIndexOf('.') >= 0 ? file.name.substring(file.name.lastIndexOf('.')) : '.png'
        let dir =  '/' + this.$store.state.LoginUser.companyId + this.typ + new Date().getTime() + suffix
        if(this.fileName){
          dir =  '/' + this.$store.state.LoginUser.companyId + this.typ + this.fileName + suffix
        }
        this.$http$({method: 'get', url: '/webServer/oss/sigle', backDirect: true}, (data) => {
          this.params = {
            key: data.dir + dir,
            policy: data.policy,
            OSSAccessKeyId: data.accessid,
            success_action_status: '200',
            callback: data.callback || '',
            signature: data.signature,
          }
          this.$refs.upload.submit()
        })
      },
      view() {
        this.dialogVisible = true;
      },
      del(){
        this.imgUrl = ''
      },
      beforeAvatarUpload(file){

        const isJPG = (file.type === 'image/jpeg') || (file.type === 'image/png') || (file.type === 'image/jpg') || (file.type === 'image/bmp') || (file.type === 'image/jif');
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG) {
          this.$warn('上传图片只能是 JPG PNG BMP JIF格式!');
        }
        if (!isLt2M) {
          this.$warn('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      },
      fileChange(file, fileList){
        if (file.percentage == 0) {
          this.getSignature(file)
        }
      },
      post(b){
        var fd = new FormData()
        for (var i in this.params) {
          fd.append(i, this.params[i])
        }
        fd.append('file', b.file)
        this.$http.post(this.path, fd)
          .then((ret) => ret.body)
          .then((data) => {
            this.success(this.params.key, b.file)

          })
          .catch(() => {
            this.error(b.file)
          })
      }

    },
    watch: {
      value(val){
        this.imgUrl = val
      },
      imgUrl(val){
        this.$emit('input', val)
      }
    }
  }
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .cover {
    top: 0;
    left: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    opacity:0;
    z-index: 99;
  }
  .cover > i{
    text-align: center;
  }
  .opc{
    opacity: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/UploadImg.vue